import textStyles from './textStyles';
const tagStyles = (tokens) => {
    const baseGreenVariant = {
        container: {
            background: tokens.CanvasPrimary100,
            borderRadius: tokens.BorderRadius02,
            borderWidth: tokens.BorderWidth01,
            borderColor: tokens.BorderLight500,
            px: tokens.Spacing04,
            py: tokens.Spacing03,
            _focus: {
                outlineColor: tokens.BorderFocus,
                outlineOffset: tokens.BorderWidth02,
                outlineWidth: tokens.BorderWidth02,
                boxShadow: 'none',
            },
            _focusVisible: {
                outlineColor: tokens.BorderFocus,
                outlineOffset: tokens.BorderWidth02,
                outlineWidth: tokens.BorderWidth02,
                boxShadow: 'none',
            },
        },
        label: textStyles(tokens).variants['dk-800-rg-5'],
    };
    const baseGreyVariant = {
        container: {
            background: tokens.CanvasInformationLight,
            borderRadius: tokens.BorderRadius02,
            borderColor: tokens.BorderMedium600,
            borderWidth: tokens.BorderWidth01,
            px: tokens.Spacing03,
            py: tokens.Spacing02,
            _focus: {
                outlineColor: tokens.BorderFocus,
                outlineOffset: tokens.BorderWidth02,
                outlineWidth: tokens.BorderWidth02,
                boxShadow: 'none',
            },
            _focusVisible: {
                outlineColor: tokens.BorderFocus,
                outlineOffset: tokens.BorderWidth02,
                outlineWidth: tokens.BorderWidth02,
                boxShadow: 'none',
            },
        },
        label: textStyles(tokens).variants['dk-800-rg-5'],
    };
    return {
        variants: {
            'green-selected': {
                ...baseGreenVariant,
                container: {
                    ...baseGreenVariant.container,
                    background: tokens.CanvasPrimary200,
                    borderColor: tokens.BorderMedium600,
                },
            },
            green: baseGreenVariant,
            grey: baseGreyVariant,
        },
    };
};
export default tagStyles;
